let ProductSlider = {};

ProductSlider = {
  init() {
    let $productSlider = $('.js-product-slider');

    if ($productSlider.length === 0) {
      return;
    }

    $.each($productSlider, function(){
      let $slider = $(this);

      let options = {
        pageDots: false,
        groupCells: false,
        cellAlign: 'left',
        percentPosition: false,
        wrapAround: false,
        contain: true,
        dragThreshold: 10,
        prevNextButtons: true,
        on: {
          ready: function() {
            $slider.removeClass('invisible');
            $slider.addClass('first-el');
          },
        },
      };

      if (matchMedia('screen and (min-width: 768px)').matches) {
        options = {
          pageDots: false,
          groupCells: true,
          cellAlign: 'left',
          percentPosition: false,
          wrapAround: true,
          contain: false,
          dragThreshold: 15,
          prevNextButtons: true,
          on: {
            ready: function() {
              $slider.removeClass('invisible');
              $slider.addClass('first-el');
            },
          },
        }
      }

      let flkty = $slider.flickity(options);
      let flktyData = $slider.data('flickity');
      var count = flktyData.cells.length;

      if (count < 4) {
        options.groupCells = false
        options.wrapAround = false
        options.prevNextButtons = false
        options.contain = true

        if (count == 5) {
          $slider.addClass('is-indented');
        }

        $slider.flickity(options);
        $slider.addClass('no-prevnext');
      }

      if (matchMedia('screen and (max-width: 767px)').matches) {
        flkty.on('change.flickity', function () {
            if (flktyData.selectedIndex == 0) {
              $slider.addClass('first-el');
            } else {
              $slider.removeClass('first-el');
            }
        });
      } else if (matchMedia('screen and (min-width: 768px)').matches) {
        flkty.on('change.flickity', function () {
          if (flktyData.selectedIndex == 0) {
            $slider.addClass('is-indented');
          } else {
            $slider.removeClass('is-indented');
          }
      });
      }
    });
  },
}

$(function () {
  ProductSlider.init();

  window.addEventListener('resize', window.stokpress.debounce(function () {
    ProductSlider.init();
  }, 500));

});

window.ProductSlider = ProductSlider;



// WEBPACK FOOTER //
// ./scripts/components/sliders/product-slider.js